import {
  Component,
  DOCUMENT,
  ElementRef,
  afterNextRender,
  inject,
  viewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RouterLink } from '@angular/router';
import { WHATSAPP_URL } from '@components/header/nav-items';
import { OmbudsmanDialog } from './ombudsman-dialog/ombudsman-dialog';
import { PrivacyPolicyDialog } from './privacy-policy-dialog/privacy-policy-dialog';

/** Script do selo "Reclame Aqui" (mesma configuração do site antigo). */
const RECLAME_AQUI = {
  src: 'https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js',
  id: 'ra-embed-verified-seal',
  dataId: 'WXo5eldkQ19ZSzJEalZTUjpwaW5wYWc=',
  target: 'ra-verified-seal',
  model: '2',
};

/** Footer global: logos, redes sociais, links, contatos, selo Reclame Aqui e dialogs. */
@Component({
  selector: 'app-footer',
  imports: [RouterLink],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  private readonly dialog = inject(MatDialog);
  private readonly document = inject(DOCUMENT);
  private readonly seal = viewChild.required<ElementRef<HTMLElement>>('seal');

  protected readonly whatsappUrl = WHATSAPP_URL;

  constructor() {
    afterNextRender(() => this.loadReclameAquiSeal());
  }

  openPrivacyPolicy(): void {
    this.dialog.open(PrivacyPolicyDialog, { width: '80vw', maxWidth: '1100px' });
  }

  openOmbudsman(): void {
    this.dialog.open(OmbudsmanDialog, { width: '80vw', maxWidth: '800px' });
  }

  private loadReclameAquiSeal(): void {
    if (this.document.getElementById(RECLAME_AQUI.id)) {
      return;
    }
    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.src = RECLAME_AQUI.src;
    script.id = RECLAME_AQUI.id;
    script.setAttribute('data-id', RECLAME_AQUI.dataId);
    script.setAttribute('data-target', RECLAME_AQUI.target);
    script.setAttribute('data-model', RECLAME_AQUI.model);
    this.seal().nativeElement.appendChild(script);
  }
}
